export class Tenant {
    constructor(
    public id: number,
    public companyName: string,
    public administrativeContact1: string,
    public administrativeContact2: string,
    public address1: string,
    public address2: string,
    public city: string,
    public state: string,
    public zipCode: string,
    public contactPhone1: string,
    public contactPhone2: string,
    public contactEmail: string) { }
}
